module.exports = __webpack_public_path__ + "img/003-man-1.bb0f93ac.svg";